<div class="float-sidebar" [class.active]="active" *ngIf="showNavBar" [class.selected]="servidorSelecionado">
  <div id="botao-abrir-sidebar-funcionario"
       class="float-button fa fa-user hint center-right module-color"
       (click)="onClickActivateButton()">
      <div class="hint-content" *ngIf="servidorSelecionado">
        <b>Matrícula: </b> {{servidorSelecionado.matricula}} <br />
      </div>
  </div>
  <div class="title">
    Selecionar Matrícula
  </div>
  <div class="container">
    <div class="select-list form-group" style="padding-top: 0px">
      <div class="row" >
        <div class="col-md-12 select-list-item" (click)="selecionarFuncionario(funcionario);"
          (keyup.enter)="selecionarFuncionario(funcionario);" *ngFor="let funcionario of matriculas; let i = index"
          [class.selected]="funcionario.id === getServidorIdSelected()">
          <div class="col-md-2 selection">
            <div class="form-group">
              <input id="subselection_{{i}}" [checked]="funcionario.id === getServidorIdSelected()"
                (click)="$event.stopImmediatePropagation();" name="funcionario" class="input-radio" type="radio">
              <label for="subselection_{{i}}"></label>
            </div>
          </div>
          <div class="col-md-10">
            <div class="row">
              <div class="col-md-4">
                <b>Entidade:</b>
              </div>
              <div class="col-md-8">
                {{funcionario.descricaoEntidade}}
              </div>
            </div>
            <div class="row">
              <div class="col-md-4">
                <b>Cargo:</b>
              </div>
              <div class="col-md-8">
                {{funcionario?.cargo?.descricao}}
              </div>
            </div>
            <div class="row">
              <div class="col-md-4">
                <b>Matrícula:</b>
              </div>
              <div class="col-md-8">
                {{funcionario.matricula}}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="row buttons">
      <div class="col-md-12 mt-xs">
        <div class="btn negative inline visible-xs-inline-block visible-sm-inline-block" (click)="openCloseTheBar()">Fechar
        </div>
      </div>
    </div>
  </div>
</div>
